export default __webpack_public_path__ + "61478a291547f8c5d7ccef4d99083fe2.svg";